export const SERVER_TYPES = [
  { value: 'VANILLA', label: 'Vanilla' },
  { value: 'PAPER', label: 'Paper' },
  { value: 'FABRIC', label: 'Fabric' },
  { value: 'QUILT', label: 'Quilt' },
  { value: 'FORGE', label: 'Forge' },
  { value: 'NEOFORGE', label: 'Neoforge' },
  { value: 'MODRINTH', label: 'Modrinth (Modpack)' },
  { value: 'CURSEFORGE', label: 'CurseForge (Modpack)' },
  { value: 'FTB', label: 'Feed The Beast (Modpack)' },
  { value: 'PURPUR', label: 'Purpur' },
  { value: 'PUFFERFISH', label: 'Pufferfish' },
  { value: 'FOLIA', label: 'Folia' },
  { value: 'SPIGOT', label: 'Spigot' },
  { value: 'SPONGEVANILLA', label: 'SpongeVanilla' },
  { value: 'KETTING', label: 'Ketting' },
  { value: 'MOHIST', label: 'Mohist' },
  { value: 'YOUER', label: 'Youer' },
  { value: 'BANNER', label: 'Banner' },
  { value: 'CRUCIBLE', label: 'Crucible' },
  { value: 'MAGMA', label: 'Magma' },
  { value: 'CATSERVER', label: 'CatServer' },
  { value: 'ARCLIGHT', label: 'Arclight' },
  { value: 'LIMBO', label: 'Limbo' },
  { value: 'NANOLIMBO', label: 'NanoLimbo' },
  { value: 'CUSTOM', label: 'Custom' }
];

export const DIFFICULTIES = ['peaceful', 'easy', 'normal', 'hard'];
export const GAMEMODES = ['survival', 'creative', 'adventure', 'spectator'];
export const LEVEL_TYPES = ['normal', 'flat', 'large_biomes', 'amplified', 'single_biome_surface'];

export const DEFAULT_SERVER_SETTINGS = {
  TYPE: 'VANILLA',
  VERSION: 'LATEST',
  MEMORY: '1G',
  MAX_PLAYERS: '20',
  MOTD: 'A Minecraft Server',
  ICON: '',
  ONLINE_MODE: 'true',
  USE_AIKAR_FLAGS: 'false',
  DIFFICULTY: 'easy',
  MODE: 'survival',
  LEVEL: 'world',
  SEED: '',
  LEVEL_TYPE: 'normal',
  VIEW_DISTANCE: '10',
  SIMULATION_DISTANCE: '10',
  SPAWN_PROTECTION: '16',
  HARDCORE: 'false',
  PVP: 'true',
  FORCE_GAMEMODE: 'false',
  ENABLE_COMMAND_BLOCK: 'false',
  ALLOW_NETHER: 'true',
  GENERATE_STRUCTURES: 'true',
  OPS: '',
  WHITELIST: '',
  ENFORCE_WHITELIST: 'false',
  NETWORK_COMPRESSION_THRESHOLD: '256',
  PREVENT_PROXY_CONNECTIONS: 'false',
  USE_NATIVE_TRANSPORT: 'true',
  PLAYER_IDLE_TIMEOUT: '0',
  RESOURCE_PACK: '',
  ALLOW_FLIGHT: 'false',
  ENABLE_RCON: 'false',
  JVM_OPTS: '',
  JVM_XX_OPTS: ''
};

export const ESSENTIAL_KEYS = ['TYPE', 'VERSION', 'MEMORY', 'DIFFICULTY', 'MODE'];
